
const changeState = (el, binding) => {
  // 禁用或者启用元素
  const inputEle = el.getElementsByTagName("input");
  const textareaEle = el.getElementsByTagName("textarea");
  for (let index = 0; index < inputEle.length; index++) {
    const element = inputEle[index];
    element.disabled = binding.value;
    element.style.backgroundColor = "#fff";
    element.style.color = "#515a6e";
    element.style.zIndex = 6;
    element.style.position = "relative";
  }
  for (let index = 0; index < textareaEle.length; index++) {
    const element = textareaEle[index];
    element.disabled = binding.value;
    element.style.zIndex = 6;
    element.style.color = "#515a6e";
    element.style.backgroundColor = "#fff";
    element.style.position = "relative";
  }
};

const myDirective = (Vue) => {
  /**
   * 禁用disable或启用
   */
  Vue.directive("disabled", {
    // 当被绑定的元素插入到 DOM 中时……
    componentUpdated(el, binding) {
      changeState(el, binding);
    },
    inserted(el, binding) {
      changeState(el, binding);
    }
  });
};
export default myDirective;
